import React from 'react';
import { ApMenu, ApButtonIcon, ApMenuItem } from '@alixpartners/ui-components';
import { useState } from 'react';

const NAME_FIELD = 'name';
const VALUE_FIELD = 'value';

export const SortMenu = ({ onChange }) => {
	const [sortField, setSortField] = useState(null);
	const [sortDirection, setSortDirection] = useState(1);

	const handleSortByName = () => {
		if (sortField === NAME_FIELD) {
			const newSortDirection = -1 * sortDirection;
			setSortDirection(newSortDirection);
			onChange({ field: NAME_FIELD, direction: newSortDirection });
		} else {
			setSortField(NAME_FIELD);
			setSortDirection(1);
			onChange({ field: NAME_FIELD, direction: 1 });
		}
	};

	const handleSortByValue = () => {
		if (sortField === VALUE_FIELD) {
			const newSortDirection = -1 * sortDirection;
			setSortDirection(newSortDirection);
			onChange({ field: VALUE_FIELD, direction: newSortDirection });
		} else {
			setSortField(VALUE_FIELD);
			setSortDirection(1);
			onChange({ field: VALUE_FIELD, direction: 1 });
		}
	};

	return (
		<ApMenu button={<ApButtonIcon iconName="sort" />} placement="bottom-end">
			<ApMenuItem onClick={handleSortByName}>Sort by name (A-Z)</ApMenuItem>
			<ApMenuItem onClick={handleSortByValue}>Sort by spend value</ApMenuItem>
		</ApMenu>
	);
};

export default SortMenu;
